var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTemplateFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2V5H22V2.414L21.586 2H19V0H22L22.707 0.293L23.707 1.293L24 2ZM2 2.414L2.414 2H5V0H2L1.293 0.293L0.293 1.293L0 2V5H2V2.414ZM2 21.586V19H0V22L0.293 22.707L1.293 23.707L2 24H5V22H2.414L2 21.586ZM22 21.586L21.586 22H19V24H22L22.707 23.707L23.707 22.707L24 22V19H22V21.586ZM19.707 18.707L18.707 19.707L18 20H6L5.293 19.707L4.293 18.707L4 18V6L4.293 5.293L5.293 4.293L6 4H10L10.707 4.293L11.707 5.293L12 6H18L18.707 6.293L19.707 7.293L20 8V18L19.707 18.707Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplateFolder);
export default __webpack_public_path__ + "static/1778142529/media/icon-template-folder.e198fb43cc523bc6d701880afca5b23a.svg";
export { ForwardRef as ReactComponent };